<template>
    <div>
        <FullPageLoader :isLoading="loading" />

        <b-modal :active.sync="inviteModalOpen" class="invitemodal" :width="640" scroll="keep">
            <div class="modal-card">
                <header class="modal-card-head"><p class="modal-card-title">Organisatie uitnodigen deelname PlanitEasy</p></header>
                <section class="modal-card-body" style="overflow: hidden;border-radius:0;">
                    <h4>Algemene controles</h4>

                    <b-field>
                        <b-checkbox v-model="inviteChecklist.hasUsers" disabled>
                            Organisatie heeft minimaal 1 administrator of eigenaar.
                        </b-checkbox>
                    </b-field>
                    <b-field>
                        <b-checkbox v-model="inviteChecklist.templates">
                            Contract sjablonen voor de huur overeenkomst en algemeen zijn beide aangevuld.
                        </b-checkbox>
                    </b-field>
                    <b-field>
                        <b-checkbox v-model="inviteChecklist.settings">
                            Er is met de eigenaar door de organisatie instellingen gegaan en waar nodig aangepast.
                        </b-checkbox>
                    </b-field>

                    <b-notification type="is-warning" size="is-small" role="alert" v-show="!record.paynl_active">
                        <strong>Let op:</strong> Pay.nl is niet ingesteld!
                    </b-notification>

                    <div v-show="record.paynl_active">
                        <hr>

                        <h4>Pay.nl</h4>
                        <b-field>
                            <b-checkbox v-model="inviteChecklist.paynl_location">
                                Er is gecontroleerd bij de verkooplocatie in Pay.nl dat incasso mogelijk en geactiveerd is.
                            </b-checkbox>
                        </b-field>

                        <b-field>
                            <b-checkbox v-model="inviteChecklist.paynl_mode">
                                De modus binnen de verkooplocatie staat op "Live, betalingen actief!" en niet (meer) op "Test modus".
                            </b-checkbox>
                        </b-field>

                        <b-field>
                            <b-checkbox v-model="inviteChecklist.paynl_secret">
                                De "secret" code die ingevuld is, is de secret van de API token en niet de "Secret" code van de serviceId.
                            </b-checkbox>
                        </b-field>

                        <b-field>
                            <b-checkbox v-model="inviteChecklist.paynl_rights">
                                De rechtengroepen binnen de API token staat op "Alle rechten van de Merchant".
                            </b-checkbox>
                        </b-field>

                        <b-field>
                            <b-checkbox v-model="inviteChecklist.paynl_exchange">
                                Er is gecontroleerd dat bij de verkooplocatie in Pay.nl de Exchange settings aan staan en de Exchange URL ingevuld is met <code>https://</code>&nbsp;<code>www.planiteasy.nl/paynlexchange</code>. Aanroep herhalen aan en op "11 keer binnen 24 uur (gebalanceerd)".
                            </b-checkbox>
                        </b-field>
                    </div>
                </section>
                <footer class="modal-card-foot" :key="modalKey">
                    <b-button type="is-light" @click="inviteModalOpen = false, inviting = false;">Annuleren</b-button>
                    <b-button type="is-success" @click="sendInvite" :loading="inviting" :disabled="!invitePossible">Uitnodigen</b-button>
                </footer>
            </div>
        </b-modal>

        <div class="row">
            <div class="column medium-3 text-right float-right" v-if="(type == 'edit' || type == 'new') && $store.state.user.role == 'pit'">
                <b-button tag="router-link" :to="{ name: 'OrganisationsOverview' }" type="is-dark">Terug naar overzicht</b-button>
            </div>
            <div class="column medium-9">
                <h1 class="title">{{ type == 'new' ? 'Nieuwe organisatie' : type == 'edit' ? record.name : 'Mijn instellingen' }}</h1>
            </div>
        </div>

        <div class="row">
            <div class="column">
                <form class="form">
                    <b-tabs size="is-medium" class="block" v-model="tabIndex" :key="updateKey">
                        <b-tab-item label="Algemeen">
                            <h3>Algemeen</h3>

                            <div v-if="$store.state.user.role == 'pit' || user.is_admin">
                                <b-field label="Organisatie naam"
                                    :message="getError(errors, 'name')"
                                    :type="getType(errors, 'name', '')"
                                >
                                    <b-input v-model="record.name" placeholder="Mijn bedrijfsnaam"></b-input>
                                </b-field>

                                <b-field label="Organisatie naam (afkorting) -- voor PIT admins"
                                    :message="getError(errors, 'short_name')"
                                    :type="getType(errors, 'short_name', '')"
                                    v-if="$store.state.user.role == 'pit'"
                                >
                                    <b-input v-model="record.short_name" placeholder="Mijn bedrijfsnaam (afkorting)"></b-input>
                                </b-field>

                                <b-field label="Type"
                                    :message="getError(errors, 'type')"
                                    :type="getType(errors, 'type', '')"
                                >
                                    <b-select v-model="record.type" expanded>
                                        <option value="">-- Maak een keuze --</option>
                                        <option value="box">Box storage</option>
                                    </b-select>
                                </b-field>
                            </div>
                            <b-notification v-else>
                                <p class="marginbottom0">Organisatie gegevens zijn enkel aanpasbaar door een administrator.</p>
                            </b-notification>
                        </b-tab-item>

                        <b-tab-item :label="record.locations && record.locations.length > 1 ? 'Vestigingen' : 'Vestiging'">
                            <div class="row">
                                <div class="column">
                                    <h3>Vestigingen</h3>
                                    <p>
                                        Beheer hier de vestiging(en) van de organisatie. De standaardvestiging wordt gebruikt voor algemene communicatie en huisstijl.<br>
                                        Het is mogelijk om meerdere vestigingen toe te voegen om verschillende bedrijfsnamen, logos en adressen op contracten en facturen te maken en andere contract sjablonen te gebruiken.<br>
                                    </p>
                                </div>
                                <div class="column text-right" v-if="$store.state.user.role == 'pit' || user.is_admin">
                                    <b-dropdown position="is-bottom-left" aria-role="menu" :triggers="['hover']">
                                        <template #trigger>
                                            <b-button type="is-primary" icon-right="chevron-down">
                                                Nieuwe vestiging toevoegen
                                            </b-button>
                                        </template>
                                        <b-dropdown-item @click="addEmptyLocation" aria-role="menuitem">
                                            Begin leeg
                                        </b-dropdown-item>
                                        <b-dropdown-item @click="addDuplicateLocation" aria-role="menuitem" :disabled="!record.locations || record.locations.length === 0">
                                            Dupliceren van standaard
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </div>
                            </div>

                            <div class="locations-container" v-if="$store.state.user.role == 'pit' || user.is_admin">
                                <div
                                    class="card mb-4"
                                    v-for="(location, index) in record.locations"
                                    :key="location.id || `new-${index}`"
                                >
                                    <header class="card-header" @click="openLocationIndex = openLocationIndex === index ? -1 : index" style="cursor: pointer;">
                                        <p class="card-header-title" style="margin: 0;">
                                            {{ location.name || 'Nieuwe vestiging' }}&nbsp;{{ location.city ? `- ${location.city}` : '' }}
                                            <b-tag type="is-success" v-if="isDefault(location)" class="ml-2">Standaard</b-tag>
                                        </p>
                                        <a class="card-header-icon">
                                            <b-icon :icon="openLocationIndex === index ? 'chevron-up' : 'chevron-down'"></b-icon>
                                        </a>
                                    </header>
                                    <slide-up-down :active="openLocationIndex === index" :duration="300">
                                        <div class="card-content">
                                            <b-tabs
                                                class="organisation-tabs"
                                                vertical
                                                type="is-boxed"
                                            >
                                                <b-tab-item label="Gegevens">
                                                    <b-field label="Naam vestiging" :message="getLocationError(index, 'name')" :type="getLocationErrorType(index, 'name')">
                                                        <b-input v-model="location.name"></b-input>
                                                    </b-field>
                                                    <div class="row">
                                                        <div class="column medium-6"><b-field label="Straat" :message="getLocationError(index, 'address')" :type="getLocationErrorType(index, 'address')"><b-input v-model="location.address"></b-input></b-field></div>
                                                        <div class="column medium-6"><b-field label="Nummer" :message="getLocationError(index, 'address2')" :type="getLocationErrorType(index, 'address2')"><b-input v-model="location.address2"></b-input></b-field></div>
                                                        <div class="column medium-6"><b-field label="Postcode" :message="getLocationError(index, 'zipcode')" :type="getLocationErrorType(index, 'zipcode')"><b-input v-model="location.zipcode"></b-input></b-field></div>
                                                        <div class="column medium-6"><b-field label="Plaats" :message="getLocationError(index, 'city')" :type="getLocationErrorType(index, 'city')"><b-input v-model="location.city"></b-input></b-field></div>
                                                        <div class="column medium-12">
                                                            <b-field label="Land" :message="getLocationError(index, 'country')" :type="getLocationErrorType(index, 'country')">
                                                                <b-select expanded v-model="location.country">
                                                                    <option value="Nederland">Nederland</option>
                                                                    <option value="Belgie">Belgie</option>
                                                                </b-select>
                                                            </b-field>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="column medium-6">
                                                            <b-field label="BTW nummer" :message="getLocationError(index, 'btw')" :type="getLocationErrorType(index, 'btw')"><b-input v-model="location.btw"></b-input></b-field>
                                                        </div>
                                                        <div class="column medium-6">
                                                            <b-field label="KvK nummer" :message="getLocationError(index, 'kvk')" :type="getLocationErrorType(index, 'kvk')"><b-input v-model="location.kvk"></b-input></b-field>
                                                        </div>
                                                    </div>
                                                </b-tab-item>
                                                <b-tab-item label="Contact">
                                                    <b-field label="E-mailadres" :message="getLocationError(index, 'email')" :type="getLocationErrorType(index, 'email')"><b-input v-model="location.email"></b-input></b-field>
                                                    <b-field label="Antwoord e-mailadres" :message="getLocationError(index, 'reply_to')" :type="getLocationErrorType(index, 'reply_to')"><b-input v-model="location.reply_to"></b-input></b-field>
                                                    <b-field label="Website" :message="getLocationError(index, 'website')" :type="getLocationErrorType(index, 'website')"><b-input v-model="location.website"></b-input></b-field>
                                                    <b-field label="Telefoonnummer" :message="getLocationError(index, 'telephone')" :type="getLocationErrorType(index, 'telephone')"><b-input type="number" v-model="location.telephone"></b-input></b-field>
                                                    <b-field label="Mobiel nummer" :message="getLocationError(index, 'mobile')" :type="getLocationErrorType(index, 'mobile')"><b-input type="number" v-model="location.mobile"></b-input></b-field>
                                                </b-tab-item>
                                                <b-tab-item label="Financieel">
                                                    <b-field label="Naam bankrekening (t.a.v.)" :message="getLocationError(index, 'bank_name')" :type="getLocationErrorType(index, 'bank_name')"><b-input v-model="location.bank_name"></b-input></b-field>
                                                    <b-field label="Bankrekeningnummer (IBAN)" :message="getLocationError(index, 'bank_iban')" :type="getLocationErrorType(index, 'bank_iban')"><b-input v-model="location.bank_iban"></b-input></b-field>
                                                </b-tab-item>
                                                <b-tab-item label="Huisstijl">
                                                    <p><strong>Logo (.png bestand)</strong></p>
                                                    <span v-if="typeof(location.logo) == 'string'">
                                                        <img :src="location.logo" style="width: auto;max-height: 75px;margin-bottom: 15px;max-width: 250px;" alt="Logo">
                                                    </span>
                                                    <b-field class="file">
                                                        <b-upload @input="file => uploadFile(file, 'logos', 750, `locations[${index}].logo`)">
                                                            <a class="button is-primary">
                                                                <b-icon icon="upload"></b-icon>
                                                                <span>Logo uploaden</span>
                                                            </a>
                                                        </b-upload>
                                                    </b-field>
                                                    <b-button v-if="location.logo" type="is-danger" outlined @click="deleteLogo(location)" class="mt-2">Logo verwijderen</b-button>

                                                    <br><br>

                                                    <div class="row">
                                                        <div class="column small-4">
                                                            <b-field label="Primaire kleur">
                                                                <v-swatches v-model="location.color1" popover-x="right" show-fallback></v-swatches>
                                                            </b-field>
                                                        </div>
                                                        <div class="column small-4 end">
                                                            <b-field label="Secundaire kleur">
                                                                <v-swatches v-model="location.color2" popover-x="right" show-fallback></v-swatches>
                                                            </b-field>
                                                        </div>
                                                    </div>

                                                    <hr>

                                                    <p><strong>Watermerk (.png bestand)</strong></p>
                                                    <span v-if="typeof(location.watermark) == 'string'">
                                                        <img :src="location.watermark" style="width: auto;max-height: 75px;margin-bottom: 15px;max-width: 250px;" alt="Watermerk">
                                                    </span>

                                                    <b-notification type="is-info is-light" :active.sync="showRealWatermarkUpload">
                                                        <p class="mb-2"><strong>Let op:</strong> Het watermerk moet een .png bestand zijn. Verplicht formaat van 842px hoog en 596px breed. Het is belangrijk dat de kleur van het watermerk bijna transparant of lichtgrijs is om de tekst goed te lezen.</p>
                                                        <p>Bekijk altijd hoe het resultaat eruit ziet in de voorbeeld factuur-PDF.</p>
                                                        <b-field class="file">
                                                            <b-upload @input="file => uploadFile(file, 'watermarks', 2000, `locations[${index}].watermark`)">
                                                                <a class="button is-dark">
                                                                    <b-icon icon="upload"></b-icon>
                                                                    <span>Klik om te uploaden</span>
                                                                </a>
                                                            </b-upload>
                                                        </b-field>
                                                    </b-notification>

                                                    <div class="button-group mt-2">
                                                        <b-button v-if="!showRealWatermarkUpload" type="is-primary" @click="showRealWatermarkUpload = true" icon-left="upload">Watermerk uploaden</b-button>
                                                        <b-button v-if="location.watermark" type="is-danger" outlined @click="deleteWatermark(location)">Watermerk verwijderen</b-button>
                                                    </div>
                                                </b-tab-item>
                                            </b-tabs>
                                        </div>
                                        <footer class="card-footer" style="border-top: 1px solid #dbdbdb; padding: 1rem; justify-content: flex-end; display: flex;">
                                            <div class="buttons">
                                                <b-button
                                                    type="is-success"
                                                    outlined
                                                    @click.prevent="setDefaultLocation(location)"
                                                    :disabled="isDefault(location)">
                                                    Instellen als standaard
                                                </b-button>
                                                <b-button
                                                    type="is-danger"
                                                    outlined
                                                    @click.prevent="removeLocation(index)"
                                                    :disabled="isDefault(location) || record.locations.length <= 1">
                                                    Verwijderen
                                                </b-button>
                                            </div>
                                        </footer>
                                    </slide-up-down>
                                </div>
                            </div>
                            <b-notification v-else>
                                <p class="marginbottom0">Vestigingen zijn enkel aanpasbaar door een administrator.</p>
                            </b-notification>
                        </b-tab-item>

                        <b-tab-item label="Instellingen">
                            <h3>Instellingen</h3>

                            <b-message title="Demo" type="is-info" aria-close-label="Sluiten" v-if="environment == 'demo'">
                                Het aanpassen van de geavanceerde organisatie instellingen is uitgeschakeld in de demo omgeving.
                            </b-message>
                            <b-message title="Let op" type="is-info" aria-close-label="Sluiten" v-else>
                                Het is raadzaam om na het aanpassen van organisatie-instellingen opnieuw uit- en in te loggen.
                            </b-message>

                            <div v-if="$store.state.user.role == 'pit' || user.is_admin">
                                <b-tabs
                                    class="organisation-tabs"
                                    v-if="_.has(record, 'settings')"
                                    type="is-boxed"
                                    v-model="settingsTabIndex"
                                    vertical
                                    :key="updateKey"
                                >
                                    <b-tab-item label="Algemeen">
                                        <h5>Algemeen</h5>
                                        <b-field>
                                            <b-checkbox v-model="record.settings.dashboard_onlyadmin" :true-value="1" :disabled="environment == 'demo'">
                                                Het dashboard enkel beschikbaar maken voor de administrators.
                                            </b-checkbox>
                                        </b-field>

                                        <b-field>
                                            <b-checkbox v-model="record.settings.hide_tax_invoice" :true-value="1" :disabled="environment == 'demo'">
                                                BTW niet tonen op factuur van particulieren facturen.
                                            </b-checkbox>
                                        </b-field>

                                        <b-field>
                                            <b-checkbox v-model="record.settings.confirm_stop" :true-value="1" :disabled="environment == 'demo'">
                                                Contract niet automatisch stopzetten, eerst bevestiging vanuit beheer.
                                                <b-tooltip label="Bevestiging stopzetten verplicht, optie om contract te stoppen of maand door te laten lopen incl. facturatie.">
                                                    <b-icon size="is-small" icon="info-circle" />
                                                </b-tooltip>
                                            </b-checkbox>
                                        </b-field>
                                    </b-tab-item>

                                    <b-tab-item label="Rechten">
                                        <h5>Rechten</h5>
                                        <b-field>
                                            <b-checkbox v-model="record.settings.strictroles" :true-value="1" :disabled="environment == 'demo'">
                                                Enkel een administrator mag organisatie instelligen, producten, communicatie en contract sjablonen aanpassen.
                                            </b-checkbox>
                                        </b-field>

                                        <b-field>
                                            <b-checkbox v-model="record.settings.strictcontracts" :true-value="1" :disabled="environment == 'demo'">
                                                Enkel een administrator mag contracten opzeggen of de einddatum aanpassen.
                                            </b-checkbox>
                                        </b-field>

                                        <b-field>
                                            <b-checkbox v-model="record.settings.strictcredits" :true-value="1" :disabled="environment == 'demo'">
                                                Enkel een administrator mag creditfacturen aanmaken.
                                            </b-checkbox>
                                        </b-field>

                                        <b-field>
                                            <b-checkbox v-model="record.settings.strictmassamail" :true-value="1" :disabled="environment == 'demo'">
                                                Enkel een administrator mag de massa mail functionaliteit gebruiken (mailen naar alle klanten).
                                            </b-checkbox>
                                        </b-field>

                                        <b-field>
                                            <b-checkbox v-model="record.settings.contractfiledelete" :true-value="1" :disabled="environment == 'demo'">
                                                Enkel een administrator mag bestanden verwijderen in een contract.
                                            </b-checkbox>
                                        </b-field>

                                        <b-field>
                                            <b-checkbox v-model="record.settings.contractfileupload" :true-value="1" :disabled="environment == 'demo'">
                                                Enkel een administrator mag bestanden uploaden in een contract.
                                            </b-checkbox>
                                        </b-field>

                                        <b-field>
                                            <b-checkbox v-model="record.settings.createpricechanges" :true-value="1" :disabled="environment == 'demo'">
                                                Enkel een administrator mag prijswijzigingen doorvoeren in contracten.
                                            </b-checkbox>
                                        </b-field>

                                        <b-field>
                                            <b-checkbox v-model="record.settings.onlinerental" :true-value="1" :disabled="environment == 'demo'">
                                                Enkel een administrator mag de online verhuur instellingen aanpassen.
                                            </b-checkbox>
                                        </b-field>

                                        <b-field>
                                            <b-checkbox v-model="record.settings.escalation_admin" :true-value="1" :disabled="environment == 'demo'">
                                                Alleen de administrator mag facturen escaleren.
                                            </b-checkbox>
                                        </b-field>
                                    </b-tab-item>

                                    <b-tab-item label="Incasso's">
                                        <h5>Incasso's</h5>
                                        <b-field>
                                            <b-checkbox v-model="record.settings.earlierincassos" :true-value="1" :disabled="environment == 'demo'">
                                                Incasso's eerder inplannen dan de betaaldatum.
                                                <b-tooltip label="Incasseren duurt gemiddeld 2 tot 7 werkdagen vanaf het moment van inschieten.">
                                                    <b-icon size="is-small" icon="info-circle" />
                                                </b-tooltip>
                                            </b-checkbox>
                                        </b-field>
                                        <slide-up-down :active="showEarlierIncassos">
                                            <b-field label="Hoeveel dagen voor de factuurdatum wil je de incasso's inschieten?">
                                                <b-numberinput :editable="false" min="0" max="14" v-model="record.settings.earlierincassosdays" controls-position="compact"></b-numberinput>
                                            </b-field>
                                        </slide-up-down>
                                        <b-field>
                                            <b-checkbox v-model="record.settings.incasso_no_auto_reschedule" :true-value="1" :false-value="0" :disabled="environment == 'demo'">
                                                Incasso's <u>NIET</u> automatisch opnieuw inplannen bij een mislukte incasso.
                                                <b-tooltip label="Wanneer deze optie uitgeschakeld is, zal de incasso automatisch opnieuw ingepland worden voor over 7 dagen.">
                                                    <b-icon size="is-small" icon="info-circle" />
                                                </b-tooltip>
                                            </b-checkbox>
                                        </b-field>
                                        <b-field>
                                            <b-checkbox v-model="record.settings.stornomail" :true-value="1" :disabled="environment == 'demo'">
                                                Verstuur een e-mail naar klanten wanneer er gestorneerd wordt.
                                                <b-tooltip label="De tekst van deze e-mail is aan te passen onder communicatie.">
                                                    <b-icon size="is-small" icon="info-circle" />
                                                </b-tooltip>
                                            </b-checkbox>
                                        </b-field>
                                    </b-tab-item>

                                    <b-tab-item label="Facturatie">
                                        <h5>Facturatie</h5>
                                        <b-field label="Facturatie nummer formaat"
                                            :message="getError(errors, 'inv_number_type')"
                                            :type="getType(errors, 'inv_number_type', '')"
                                        >
                                            <b-select v-model="record.inv_number_type" expanded>
                                                <option value="">-- Maak een keuze --</option>
                                                <option value="1">20250001 - Format: [jaar][factuurnummer]</option>
                                                <option value="2">2025-0001 - Format: [jaar]-[factuurnummer]</option>
                                                <option value="3">20250101001 - Format: [jaar][maand][dag][contractId?][klant-factuurnummer]</option>
                                            </b-select>
                                        </b-field>
                                        <b-field>
                                            Standaard facturatiefrequentie
                                            <b-tooltip label="Deze facturatiefrequentie wordt standaard geselecteerd bij het aanmaken van een nieuw contract.">
                                                <b-icon size="is-small" icon="info-circle" />
                                            </b-tooltip>
                                        </b-field>
                                        <b-field>
                                            <b-select v-model="record.settings.preferred_invoice_freq" expanded>
                                                <option value="week_1">Elke week</option>
                                                <option value="week_2">Elke 2 weken</option>
                                                <option value="week_3">Elke 3 weken</option>
                                                <option value="week_4">Elke 4 weken</option>
                                                <option value="week_5">Elke 5 weken</option>
                                                <option value="month">Maandelijks</option>
                                                <option value="quarter">Elk kwartaal (3 maanden)</option>
                                                <option value="halfyear">Elk halfjaar (6 maanden)</option>
                                                <option value="year">Elk jaar (12 maanden)</option>
                                            </b-select>
                                        </b-field>
                                        <b-field label="Factuur startnummer (tellen vanaf dit nummer, wordt automatisch teruggezet naar 1 op 1 januari)"
                                            :message="getError(errors, 'inv_number_start')"
                                            :type="getType(errors, 'inv_number_start', '')"
                                        >
                                            <b-numberinput v-model="record.inv_number_start" :min="1" :max="10000" controls-position="compact"></b-numberinput>
                                        </b-field>

                                        <b-field>
                                            <b-checkbox v-model="record.settings.manualinvoices" :true-value="1" :disabled="environment == 'demo'">
                                                Handmatige facturen eerder verzenden dan de eerste van de maand.
                                            </b-checkbox>
                                        </b-field>

                                        <slide-up-down :active="showManualInvoices">
                                            <b-field label="Dag van de maand waarop de facturen voor de aankomende maand verstuurd worden:">
                                                <b-numberinput :editable="false" :min="2" :max="28" v-model="record.settings.manualpaymentday" controls-position="compact"></b-numberinput>
                                            </b-field>
                                        </slide-up-down>

                                        <b-field label="Naamgeving betaalde factuur">
                                            <b-select v-model="record.settings.payconfirm_name" expanded>
                                                <option value="confirm">Betaalbevestiging</option>
                                                <option value="invoice">Factuur met "voldaan" bedrag, totaal op 0</option>
                                            </b-select>
                                        </b-field>

                                        <hr>

                                        <h5>Opmerkingen op facturen</h5>
                                        <b-field label="Handmatige facturen">
                                            <b-input v-model="record.settings.invoice_manual_notes" rows="2" type="textarea" placeholder="Bijvoorbeeld: Gelieve te betalen binnen 14 dagen."></b-input>
                                        </b-field>

                                        <slide-up-down :active="record.paynl_active">
                                            <b-field label="Incasso facturen">
                                                <b-input v-model="record.settings.invoice_incasso_notes" rows="2" type="textarea" placeholder="Bijvoorbeeld: De betaling wordt automatisch afgeschreven."></b-input>
                                            </b-field>
                                        </slide-up-down>

                                        <hr>

                                        <div class="row">
                                            <div class="column medium-9">
                                                <h5>Factuur layout</h5>
                                                <p class="mb-4">Kies een factuur layout die het beste bij je organisatie past. Wanneer dit aangepast wordt, zal dit effectief zijn bij de toekomstige facturen.</p>
                                            </div>
                                            <div class="preview-button column medium-3 text-right">
                                                <b-button
                                                    type="is-dark"
                                                    @click="previewInvoiceLayout"
                                                    :loading="loading"
                                                >
                                                    Voorbeeld bekijken
                                                </b-button>
                                            </div>
                                        </div>

                                        <b-field label="Logo positie">
                                            <b-select v-model="record.settings.invoice_logo_position" expanded>
                                                <option value="left">Links</option>
                                                <option value="center">Midden</option>
                                                <option value="right">Rechts</option>
                                            </b-select>
                                        </b-field>

                                        <!-- TODO: make three variations of the invoice layout images -->
                                        <!-- TODO: When switching change the images! -->

                                        <b-field label="Layout"></b-field>
                                        <div class="invoice-layout-grid" :key="invoiceLayoutKey">
                                            <!-- Layout 1 -->
                                            <div
                                                class="invoice-layout-tile"
                                                :class="{ 'is-selected': record.settings.invoice_layout === 1 || !record.settings.invoice_layout }"
                                                @click="toggleInvoiceLayout(1)"
                                            >
                                                <div class="preview-image">
                                                    <img :src="`/images/invoices/invoice_1_${record.settings.invoice_logo_position}.png`" alt="Layout #1">
                                                </div>
                                                <div class="layout-info">
                                                    <strong>Standaard modern</strong>
                                                    <p>Standaard layout met een overzichtelijke en gestructureerde indeling.</p>
                                                </div>
                                                <div class="selected-indicator" v-show="record.settings && record.settings.invoice_layout === 1">
                                                    <b-icon icon="check-circle"></b-icon>
                                                </div>
                                            </div>

                                            <!-- Layout 2 -->
                                            <div
                                                class="invoice-layout-tile"
                                                :class="{ 'is-selected': record.settings.invoice_layout === 2 }"
                                                @click="toggleInvoiceLayout(2)"
                                            >
                                                <div class="preview-image">
                                                    <img :src="`/images/invoices/invoice_2_${record.settings.invoice_logo_position}.png`" alt="Layout 2">
                                                </div>
                                                <div class="layout-info">
                                                    <strong><span v-if="showNewLabel"><b-tag type="is-success">Nieuw</b-tag>&nbsp;</span>Minimalistisch en rustig</strong>
                                                    <p>Simpele layout met gecentreerde contactgegevens aan de onderkant.</p>
                                                </div>
                                                <div class="selected-indicator" v-show="record.settings && record.settings.invoice_layout === 2">
                                                    <b-icon icon="check-circle"></b-icon>
                                                </div>
                                            </div>
                                        </div>

                                        <br>
                                    </b-tab-item>

                                    <b-tab-item label="Escalatie">
                                        <h5>Escalatie</h5>
                                        <p>Door de escalatie zal de factuur worden weergegeven onder een eigen categorie om eventuele vervolgstappen (deurwaarder) te nemen.</p>
                                        <b-field>
                                            <b-checkbox v-model="record.settings.escalation" :true-value="1" :disabled="environment == 'demo'">
                                                Mogelijkheid tot escalatie van facturen toestaan.
                                            </b-checkbox>
                                        </b-field>
                                        <slide-up-down :active="record.settings.escalation == 1">
                                            <b-field label="Naamgeving escalatie">
                                                <b-select v-model="record.settings.escalation_name" expanded>
                                                    <option value="escalatie">Escalatie</option>
                                                    <option value="deurwaarder">Deurwaarder</option>
                                                </b-select>
                                            </b-field>
                                            <fieldset style="padding: 1rem; border: 1px solid #e0e0e0;background: #f7f7f7;">
                                                <p><small>Dit e-mailadres wordt gebruikt voor alle communicatie omtrent escalaties. Als dit niet is ingevuld, wordt het standaard naar de organisatie eigenaar gestuurd.</small></p>
                                                <b-field label="E-mailadres escalaties">
                                                    <b-input v-model="record.settings.escalation_email" placeholder="Alternatief e-mailadres"></b-input>
                                                </b-field>
                                            </fieldset>
                                            <br>
                                            <b-field>
                                                <b-checkbox v-model="record.settings.escalation_message_alert"  :true-value="1" :disabled="environment == 'demo'">
                                                    Een e-mailmelding sturen wanneer de deurwaarder een bericht heeft geplaatst.
                                                </b-checkbox>
                                            </b-field>
                                            <b-field>
                                                <b-checkbox v-model="record.settings.escalation_out" :true-value="1" :disabled="environment == 'demo'">
                                                    Escaleren naar een deurwaarder toestaan.
                                                </b-checkbox>
                                            </b-field>
                                            <b-field>
                                                <b-checkbox v-model="record.settings.escalation_out_admin" :true-value="1" :disabled="environment == 'demo'">
                                                    Alleen de administrator mag facturen escaleren naar een deurwaarder.
                                                </b-checkbox>
                                            </b-field>

                                            <slide-up-down :active="record.settings.escalation_out == 1">
                                                <fieldset style="padding: 1rem; border: 1px solid #e0e0e0;background: #f7f7f7;">
                                                    <p><strong>Gegevens deurwaarderskantoor</strong></p>
                                                    <b-field label="Naam kantoor">
                                                        <b-input v-model="record.settings.escalation_out_name" placeholder="Naam ontvanger deurwaarderskantoor"></b-input>
                                                    </b-field>
                                                    <b-field label="E-mailadres">
                                                        <b-input v-model="record.settings.escalation_out_email" placeholder="E-mailadres deurwaarderskantoor"></b-input>
                                                    </b-field>
                                                </fieldset>
                                            </slide-up-down>
                                        </slide-up-down>
                                    </b-tab-item>

                                    <b-tab-item label="Pay.nl" icon="lock" :visible="user.role == 'pit' && $store.state.env != 'demo'">
                                        <div v-if="user.role == 'pit'">
                                            <div class="row">
                                                <div class="column medium-6">
                                                    <h5>Pay.nl</h5>
                                                    <b-tag v-if="hasPaynlChanges" type="is-warning" size="is-small" class="paynl-changes-warning">
                                                        Wijzigingen gedetecteerd
                                                    </b-tag>
                                                </div>
                                                <div class="column medium-6 text-right">
                                                    <a href="https://developer.pay.nl/docs/connecting-your-pay-account" target="_blank" class="button is-secondary">
                                                        <b-icon size="is-small" icon="info-circle" />
                                                    </a>
                                                    <b-button
                                                        v-if="hasPaynlChanges"
                                                        type="is-warning"
                                                        @click="resetPaynlChanges"
                                                    >
                                                        Wijzigingen ongedaan maken
                                                    </b-button>
                                                    <b-button type="is-dark" @click="testPaySettings" :loading="testingPaySettings" :disabled="testingPaySettings">Test verbinding</b-button>
                                                </div>
                                            </div>

                                            <b-field>
                                                <b-checkbox v-model="record.paynl_active">
                                                    Betalen met Pay.nl ingeschakeld
                                                </b-checkbox>
                                            </b-field>

                                            <div class="row">
                                                <div class="column">
                                                    <b-field label="Service ID"
                                                        :message="getError(errors, 'paynl_serviceId')"
                                                        :type="getType(errors, 'paynl_serviceId', '')"
                                                    >
                                                        <b-input v-model="record.paynl_serviceId" name="paynl_serviceid" placeholder="SL-1234-5678" :disabled="loading" autocomplete="off"></b-input>
                                                    </b-field>

                                                    <hr>

                                                    <h5>API Token</h5>

                                                    <b-field label="Token"
                                                        :message="getError(errors, 'paynl_token')"
                                                        :type="getType(errors, 'paynl_token', '')"
                                                    >
                                                        <b-input v-model="record.paynl_token" name="paynl_token" placeholder="AT-1234-5678" :disabled="loading" autocomplete="off"></b-input>
                                                    </b-field>

                                                    <b-field label="Token secret"
                                                        :message="getError(errors, 'paynl_token_secret')"
                                                        :type="getType(errors, 'paynl_token_secret', '')"
                                                    >
                                                        <b-input :type="type == 'new' ? '' : 'password'" name="paynl_password" v-model="record.paynl_token_secret" placeholder="40 tekens" :disabled="loading" :password-reveal="type != 'new'" autocomplete="off"></b-input>
                                                    </b-field>
                                                </div>
                                            </div>
                                        </div>
                                    </b-tab-item>

                                    <b-tab-item label="Connect" :visible="($store.state.user.role == 'pit' || user.is_admin) && $store.state.env != 'demo'">
                                        <div class="row">
                                            <div class="column">
                                                <h3>PlanitEasy Connect</h3>
                                                <p>Connect is een programma welk toegang van klanten kan beheren vanuit PlanitEasy.</p>

                                                <p><strong>Momenteel ondersteunen wij:</strong>
                                                    <ul>
                                                        <li>Paxton</li>
                                                    </ul>
                                                </p>
                                            </div>
                                        </div>

                                        <hr>

                                        <b-field>
                                            <b-checkbox v-model="record.connect" :true-value="1">
                                                Maakt gebruik van PlanitEasy Connect
                                            </b-checkbox>
                                        </b-field>

                                        <ConnectDownload/>
                                    </b-tab-item>
                                </b-tabs>
                            </div>
                            <b-message v-else>
                                <p class="marginbottom0">Organisatie instellingen zijn enkel aanpasbaar door een administrator.</p>
                            </b-message>
                        </b-tab-item>

                        <b-tab-item label="Gebruikers" v-if="($store.state.user.role == 'pit' && type != 'user_edit') || user.is_admin">
                            <div class="row">
                                <div class="column is-9">
                                    <h3>Gebruikers</h3>
                                    <p>
                                        Hieronder vind je de gebruikers gekoppeld aan deze organisatie.<br>
                                        <span v-if="record.invited === 1">De nieuw toegevoegde gebruiker krijgt direct een e-mail.</span>
                                        <span v-if="record.invited === 0">De gebruikers krijgen direct een e-mail wanneer de organisatie uitgenodigd is.</span>
                                    </p>
                                </div>
                                <div class="column is-3 text-right">
                                    <b-button
                                        type="is-primary"
                                        @click="$refs['UsersOverviewTable'].addUser('new', record.id)"
                                        v-if="record.id"
                                    >Gebruiker toevoegen</b-button>
                                </div>
                            </div>

                            <div class="row">
                                <div class="column is-12">
                                    <b-notification type="is-warning" role="alert" v-if="!record.id">
                                        Om de gebruiker toe te voegen dient de organisatie eerst opgeslagen te worden.
                                    </b-notification>
                                    <UsersOverviewTable
                                        ref="UsersOverviewTable"
                                        from="OrganisationRecord"
                                        :organisation_id="record.id"
                                        v-else
                                    />
                                </div>
                            </div>
                        </b-tab-item>

                        <b-tab-item label="Logs" v-if="type == 'edit' || type == 'user_edit' && user.role == 'pit'">
                            <h3>Logs</h3>

                            <LogsRecord
                                ref="LogsRecord"
                                searchParamName="OrganisationRecord"
                                :getFilters="{0: {name: record.name, query: { subject_type: 'App\\Organisation', subject_id: record.id }}}"
                            />
                        </b-tab-item>
                    </b-tabs>
                </form>

                <slide-up-down :active="showFormFooter" :duration="500">
                    <div class="row">
                        <div class="column text-right">
                            <div class="formfooter">
                                <!-- [Opslaan en afsluiten] - [Opslaan] -->
                                <b-button v-if="type == 'new' && $store.state.user.role == 'pit'" type="is-success" :loading="loading" @click="saveAndQuit(false)">Opslaan en sluiten</b-button>
                                <b-button v-if="type == 'edit' && $store.state.user.role == 'pit'" type="is-success" :loading="loading" @click="saveAndQuit(record.invited)">Opslaan en sluiten</b-button>

                                <b-button v-else-if="type == 'user_edit'" :disabled="!user.is_admin" type="is-success" :loading="loading" @click="saveRecord()">Opslaan</b-button>

                                <!-- [Uitnodigen] -->
                                <b-button v-if="(type == 'new' || !this.record.invited) && $store.state.user.role == 'pit'" type="is-dark" :loading="loading" @click="invite()">Uitnodigen</b-button>
                            </div>
                        </div>
                    </div>
                </slide-up-down>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import VSwatches from 'vue-swatches'
import LogsRecord from '../logs/LogsRecord'
import UsersOverviewTable from '../users/UsersOverviewTable'
import formvalidationMixin from '@/mixins/formvalidationMixin.js'
import toastMixin from '@/mixins/toastMixins.js'
import ConnectDownload from '../connect/ConnectDownload'
import _ from 'lodash'

export default {
    name: 'OrganisationRecord',

    mixins: [formvalidationMixin, toastMixin],

    components: {
        VSwatches,
        LogsRecord,
        UsersOverviewTable,
        ConnectDownload
    },

    data () {
        return {
            modalKey: 0,
            updateKey: 0,
            invoiceLayoutKey: 0,
            tabIndex: 0,
            settingsTabIndex: 0,
            id: null,
            type: null,
            loading: false,
            showRealWatermarkUpload: false,
            openLocationIndex: 0,
            record: {
                name: '',
                paynl_active: false,
                locations: [],
                settings: {},
            },
            errors: {},
            showFormFooter: false,

            inviteChecklist: {
                hasUsers: false,
                templates: false,
                settings: false,
                paynl_secret: true,
                paynl_location: true,
                paynl_mode: true,
                paynl_rights: false,
                paynl_exchange: false
            },
            inviteModalOpen: false,
            inviting: false,

            testingPaySettings: false,

            // Track original Pay.nl values to detect actual changes
            originalPaynlData: {
                serviceId: '',
                token: '',
                token_secret: '',
                active: false
            },
        }
    },

    computed: {
        user() {
            return this.$store.state.user
        },

        hasMultipleLocations() {
            return this.record && this.record.locations && this.record.locations.length > 1
        },

        defaultLocation() {
            if (!this.record || !this.record.locations || this.record.locations.length === 0) {
                return {};
            }

            let location;
            if (this.record.default_location_id) {
                location = this.record.locations.find(l => l.id === this.record.default_location_id);
            }

            if (!location) {
                location = this.record.locations[0];
            }

            return location;
        },

        editableLocation() {
            if (this.hasMultipleLocations) {
                return null;
            }
            return this.record && this.record.locations && this.record.locations.length > 0 ? this.record.locations[0] : {};
        },

        invitePossible(){
            if (this.environment == 'demo') return true

            if (this.record.paynl_active) {
                return _.every(this.inviteChecklist)
            } else {
                return _.every(this.inviteChecklist, (value, key) => !key.startsWith('paynl_') || value)
            }
        },

        environment() {
            return this.$store.state.env
        },

        showNewLabel() {
            const endDate = new Date('2025-04-30')
            const today = new Date()
            return today <= endDate
        },

        showManualInvoices() {
            return this.settingsTabIndex === 3 && this.record?.settings?.manualinvoices == 1
        },

        showEarlierIncassos() {
            return this.settingsTabIndex === 2 && this.record?.settings?.earlierincassos == 1
        },

        cssVars() {
            if (!this.defaultLocation) return {}
            return {
                '--color1': this.defaultLocation.color1,
                '--color2': this.defaultLocation.color2
            }
        },

        // Check if Pay.nl data has actually been modified by the user
        hasPaynlChanges() {
            // Check if any Pay.nl field has been modified
            const hasServiceIdChanged = this.record.hasOwnProperty('paynl_serviceId') &&
                this.record.paynl_serviceId !== this.originalPaynlData.serviceId;

            const hasTokenChanged = this.record.hasOwnProperty('paynl_token') &&
                this.record.paynl_token !== this.originalPaynlData.token;

            const hasTokenSecretChanged = this.record.hasOwnProperty('paynl_token_secret') &&
                this.record.paynl_token_secret !== this.originalPaynlData.token_secret;

            const hasActiveChanged = this.record.hasOwnProperty('paynl_active') &&
                this.record.paynl_active !== this.originalPaynlData.active;

            // Special case: if Pay.nl is being disabled (set to false), always treat as changed
            const isBeingDisabled = this.record.hasOwnProperty('paynl_active') &&
                this.record.paynl_active === false &&
                this.originalPaynlData.active === true;

            return hasServiceIdChanged || hasTokenChanged || hasTokenSecretChanged || hasActiveChanged || isBeingDisabled;
        },
    },

    created() {
        // User settings
        if(this.$route.path == '/panel/instellingen/algemeen'){
            if(this.user.role == 'pit'){
                this.$router.push({name: 'OrganisationsRecord', params: {id: this.user.organisation}})
                this.$parent.$refs['SideNav'].setActiveState()

                return
            }

            this.type = 'user_edit'
            this.showFormFooter = true

            this.fetchRecord(true)
            return
        }

        // Admin settings (edit or new)
        if(this.$route.params.id == 'nieuw'){
            this.type = 'new'

            this.record.name = ''
            this.record.invited = false
            this.record.settings = {}
            this.record.settings.invoice_layout = 1 // Set default invoice layout to 1.
            this.record.settings.invoice_logo_position = 'left'
            this.record.settings.manualinvoices = 0 // Initialize manual invoices setting
            this.record.settings.preferred_invoice_freq = 'month' // Default preferred invoice frequency

            this.record.locations = [{
                name: '',
                email: '',
                reply_to: '',
                website: '',
                telephone: '',
                mobile: '',
                btw: '',
                kvk: '',
                bank_name: '',
                bank_iban: '',
                address: '',
                address2: '',
                zipcode: '',
                city: '',
                country: 'Nederland',
                logo: null,
                watermark: null,
                color1: '#118fe4',
                color2: '#000000',
            }];
            this.record.default_location_id = null;

            Vue.set(this.record, 'inv_number_type', 1)
            Vue.set(this.record, 'inv_number_start', 1)
            this.record.settings.payconfirm_name = 'confirm'

            // Initialize Pay.nl data for new organisations
            this.record.paynl_active = false
            this.record.paynl_serviceId = ''
            this.record.paynl_token = ''
            this.record.paynl_token_secret = ''

            // Set original Pay.nl data for new organisations
            this.originalPaynlData = {
                serviceId: '',
                token: '',
                token_secret: '',
                active: false
            }

            // Ensure the record has the paynl_active property explicitly set
            Vue.set(this.record, 'paynl_active', false)

            // Vue.set(this.record, 'color1', '#118fe4')
            // Vue.set(this.record, 'color2', '#000000')
        } else if (!isNaN(parseInt(this.$route.params.id))) {
            this.type = 'edit'
            this.id = parseInt(this.$route.params.id)

            this.fetchRecord()
        } else {
            console.error('[❌] Unknown type supplied!')
        }

        this.showFormFooter = true
    },

    methods: {
        fetchRecord (me = false) {
            this.loading = true

            axios.get(`/api/organisation/${me ? 'me' : this.$route.params.id}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.responseParsing(response)
            }).catch((error) => {
                console.error('[❌] Error while fetching organisation:', error)
                this.$buefy.toast.open({message: 'Organisatie kon niet opgehaald worden.', type: 'is-danger'})
            }).then(() => {
                this.loading = false
            })
        },

        responseParsing(response){
            // Paynl parsing
            if(_.has(response.data, 'paynl') && !_.isNull(response.data.paynl)){
                response.data.paynl_active = !!response.data.paynl.active
                response.data.paynl_serviceId = response.data.paynl.serviceId
                response.data.paynl_token = response.data.paynl.token
                response.data.paynl_token_secret = response.data.paynl.token_secret

                // Store original Pay.nl values for change detection
                this.originalPaynlData = {
                    serviceId: response.data.paynl.serviceId || '',
                    token: response.data.paynl.token || '',
                    token_secret: response.data.paynl.token_secret || '',
                    active: !!response.data.paynl.active
                }

                delete response.data.paynl
            } else {
                // Reset original Pay.nl data if no Pay.nl record exists
                this.originalPaynlData = {
                    serviceId: '',
                    token: '',
                    token_secret: '',
                    active: false
                }

                // Ensure paynl_active is explicitly set to false when no Pay.nl record exists
                response.data.paynl_active = false
            }

            if (_.isNull(response.data?.settings) ){
                response.data.settings = {
                    manualpaymentday: 2,
                    manualinvoices: 0,
                    preferred_invoice_freq: 'month'
                }
            }

            if (!response.data.locations || response.data.locations.length === 0) {
                response.data.locations = [{}];
            }

            // Set default invoice layout to 1 if not set.
            if (!_.has(response.data.settings, 'invoice_layout')) {
                Vue.set(response.data.settings, 'invoice_layout', 1)
            }

            if (!_.has(response.data.settings, 'invoice_logo_position')) {
                Vue.set(response.data.settings, 'invoice_logo_position', 'left')
            }

            if (!_.has(response.data.settings, 'payconfirm_name')) {
                Vue.set(response.data.settings, 'payconfirm_name', 'confirm')
            }

            if (!_.has(response.data.settings, 'manualinvoices')) {
                Vue.set(response.data.settings, 'manualinvoices', 0)
            }

            if (!_.has(response.data.settings, 'preferred_invoice_freq')) {
                Vue.set(response.data.settings, 'preferred_invoice_freq', 'month')
            }

            // Now set
            Vue.set(this, 'record', {
                ...this.record,
                ...response.data
            })

            const defaultIndex = this.record.locations.findIndex(l => this.isDefault(l))
            this.openLocationIndex = defaultIndex > -1 ? defaultIndex : 0

            if(response.data.users_count){
                this.inviteChecklist.hasUsers = true
            }

            // Load the logs since now we have the data.
            setTimeout(() => {
                if((this.type == 'edit' || this.type == 'user_edit') && (this.user.is_admin || this.user.role == 'pit')){
                    if(this.user.role == 'pit'){
                        this.$refs['LogsRecord'].load()
                    }

                    this.$refs['UsersOverviewTable'].fetchUsers('organisation='+this.record.id)
                }
            }, 250)
        },

        // Save and quit to overview (admin edit/new)
        saveAndQuit(validate = true) {
            validate = Boolean(validate)
            this.loading = true

            this.save(validate).then(() => {
                this.$router.push({name: 'OrganisationsOverview'})
            }).catch((error) => {
                // ..
            }).finally(() => {
                this.loading = false
            })
        },

        //Users saves
        saveRecord(){
            this.loading = true

            this.save().then((response) => {
                this.responseParsing(response)
            }).catch((error) => {
                // ?
            }).finally(() => {
                this.loading = false
            })
        },

        // Save - returns promise
        save(validate = true){
            console.log('[🔥] Saving with validation:', validate)
            this.errors = {}

            // Check if Pay.nl changes are detected and show confirmation
            if (this.hasPaynlChanges && this.user.role === 'pit') {
                return new Promise((resolve, reject) => {
                    this.$buefy.dialog.confirm({
                        title: 'Pay.nl wijzigingen gedetecteerd',
                        message: 'Er zijn wijzigingen gedetecteerd in de Pay.nl instellingen. Weet u zeker dat u deze wijzigingen wilt opslaan?',
                        confirmText: 'Ja, opslaan',
                        cancelText: 'Annuleren',
                        type: 'is-warning',
                        hasIcon: true,
                        onConfirm: () => {
                            this.performSave(validate).then(resolve).catch(reject);
                        },
                        onCancel: () => {
                            reject(new Error('Pay.nl changes cancelled by user'));
                        }
                    });
                });
            }

            return this.performSave(validate);
        },

        // Actual save implementation
        performSave(validate = true) {
            let postData = JSON.parse(JSON.stringify(this.record))
            postData.settings = JSON.stringify(postData.settings)

            // Only include Pay.nl data if it has actually been modified
            if (!this.hasPaynlChanges) {
                delete postData.paynl_serviceId
                delete postData.paynl_token
                delete postData.paynl_token_secret
                delete postData.paynl_active  // Don't send paynl_active if no changes
            } else {
                // If Pay.nl data has changed, handle it properly
                if (this.record.hasOwnProperty('paynl_active')) {
                    // Ensure it's a valid boolean value
                    postData.paynl_active = Boolean(this.record.paynl_active);

                    // Only send credential fields if they have actually changed
                    // or if Pay.nl is being enabled (to ensure required fields are present)
                    if (this.record.paynl_active === true) {
                        // When enabling Pay.nl, send all credential fields
                        postData.paynl_serviceId = this.record.paynl_serviceId || '';
                        postData.paynl_token = this.record.paynl_token || '';
                        postData.paynl_token_secret = this.record.paynl_token_secret || '';
                    } else {
                        // When disabling Pay.nl, only send credential fields if they changed
                        // This prevents overwriting existing credentials with empty values
                        if (this.record.hasOwnProperty('paynl_serviceId') &&
                            this.record.paynl_serviceId !== this.originalPaynlData.serviceId) {
                            postData.paynl_serviceId = this.record.paynl_serviceId;
                        }
                        if (this.record.hasOwnProperty('paynl_token') &&
                            this.record.paynl_token !== this.originalPaynlData.token) {
                            postData.paynl_token = this.record.paynl_token;
                        }
                        if (this.record.hasOwnProperty('paynl_token_secret') &&
                            this.record.paynl_token_secret !== this.originalPaynlData.token_secret) {
                            postData.paynl_token_secret = this.record.paynl_token_secret;
                        }
                    }
                }
            }

            return new Promise((resolve, reject) => {
                axios.post(`/api/organisation/${this.type == 'user_edit' ? 'me' : this.$route.params.id}/save?validate=${validate}`, postData, {
                    headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
                }).then((response) => {
                    if (_.has(this.record, 'connect')) {
                        this.$store.dispatch('updateConnectVisibility', !!this.record.connect)
                    }

                    // Update original Pay.nl data after successful save
                    if (this.hasPaynlChanges) {
                        this.originalPaynlData = {
                            serviceId: this.record.paynl_serviceId || '',
                            token: this.record.paynl_token || '',
                            token_secret: this.record.paynl_token_secret || '',
                            active: !!this.record.paynl_active
                        };
                    }

                    this.$buefy.toast.open({message: 'Succesvol opgeslagen!', type: 'is-success'})

                    // Update organisations in Vuex if admin
                    if(this.user.role == 'pit'){
                        this.$store.dispatch('getUser')
                    }

                    if(response.data.users_count){
                        this.inviteChecklist.hasUsers = true
                    }

                    resolve(response)
                }).catch((error) => {
                    if(_.has(error.response.data, 'error') && error.response.data.error == 'not-org-admin'){
                        this.showError('Opslaan is niet mogelijk. Alleen een administrator heeft de bevoegdheid om deze gegevens te wijzigen.')
                        return reject()
                    }

                    if(_.has(error.response.data, 'error') && error.response.data.error == 'location-has-active-contracts'){
                        this.showError(error.response.data.message)
                        return reject()
                    }

                    if(_.has(error.response.data, 'error') && error.response.data.error == 'location-has-unsent-invoices'){
                        this.showError(error.response.data.message)
                        return reject()
                    }

                    console.error('[❌] Error while saving organisation!', error)
                    this.errors = {...error.response.data.errors}

                    this.$buefy.toast.open({
                        message: 'Opslaan mislukt - Onvoldoende of onjuiste gegevens.',
                        type: 'is-danger'
                    })

                    reject()
                })
            })
        },

        invite() {
            this.loading = true

            this.save(true).then(response => {
                console.log('✅ Everything passed! lets open the invite modal')
                this.inviteModalOpen = true
            }).catch((error) => {
                console.error('Error while saving organisation', error)
            }).finally(() => {
                this.loading = false
            })
        },

        sendInvite(){
            this.inviting = true

            axios.post(`/api/organisation/${this.$route.params.id}/invite`, this.record, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.showMessage('Gebruikers uitgenodigd!')
                this.$router.push({name: 'OrganisationsOverview'})
            }).catch((error) => {
                console.error('[❌] Error while inviting organisation!', error)
                this.showError('Uitnodigen mislukt, onbekende fout.')
            })

            setTimeout(() => {
                this.inviting = false
            }, 2000)
        },

        uploadFile(file, type, width, propertyPath) {
            if (!file) return;

            this.loading = true;
            let formData = new FormData();
            formData.append('file', file);

            return axios.post(`/api/upload/${type}/${width}`, formData, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                _.set(this.record, propertyPath, response.data.path);
                Vue.delete(this.errors, propertyPath);
                this.$forceUpdate();
            }).catch((error) => {
                console.error(`[❌] Error while uploading ${type}!`, error);
                this.$buefy.toast.open({
                    message: error.response.data.error == 'error_only_png_allowed'
                        ? `${type === 'logos' ? 'Logo' : 'Watermerk'} mag alleen in .png formaat geupload worden.`
                        : _.has(error.response, 'data.message') ? error.response.data.message : 'Uploaden mislukt!',
                    type: 'is-danger'
                });
            }).finally(() => {
                this.loading = false;
            });
        },

        deleteLogo(location){
            if (!this.user.is_admin) {
                this.showError('Opslaan is niet mogelijk. Alleen een administrator kan het logo aanpassen.')
                return
            }
            location.logo = null;
            this.$forceUpdate();
        },

        testPaySettings(){
            this.testingPaySettings = true

            axios.post(`/api/organisation/${this.$route.params.id}/paynl-test`, {
                paynl_serviceId: this.record.paynl_serviceId,
                paynl_token: this.record.paynl_token,
                paynl_token_secret: this.record.paynl_token_secret
            }, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                if(response.data == 'success') {
                    this.showMessage('Verbinding met Pay.nl is succesvol!')
                    // Update original data if test is successful to avoid false change detection
                    this.originalPaynlData = {
                        serviceId: this.record.paynl_serviceId || '',
                        token: this.record.paynl_token || '',
                        token_secret: this.record.paynl_token_secret || '',
                        active: !!this.record.paynl_active
                    };
                } else if(response.data == 'connection-but-no-incasso') {
                    this.showMessage('Verbinding met Pay.nl is succesvol, maar incasso is nog niet (goed) geconfigureerd.', 'warning', 5000)
                    // Update original data if test is successful to avoid false change detection
                    this.originalPaynlData = {
                        serviceId: this.record.paynl_serviceId || '',
                        token: this.record.paynl_token || '',
                        token_secret: this.record.paynl_token_secret || '',
                        active: !!this.record.paynl_active
                    };
                } else {
                    this.showError('Verbinding met Pay.nl is mislukt!')
                }
            }).catch((error) => {
                console.log(error)
                if (_.has(error.response.data, 'errors') && Object.keys(error.response.data.errors).length) {
                    let errorMessage = ''

                    for (let errorKey in error.response.data.errors) {
                        errorMessage += error.response.data.errors[errorKey] + ' '
                    }

                    this.showError(errorMessage)
                } else {
                    this.showError(error.response.data.message || 'Verbinding met Pay.nl is mislukt!')
                }
            }).then(() => {
                this.testingPaySettings = false
            })
        },

        toggleInvoiceLayout(layout) {
            Vue.set(this.record.settings, 'invoice_layout', layout)
            this.invoiceLayoutKey = ++this.invoiceLayoutKey // refresh layouts to use new image.
        },

        previewInvoiceLayout() {
            this.loading = true;

            axios.post('/api/organisation/preview-invoice', {
                organisation_id: this.record.id,
                layout: this.record.settings.invoice_layout || '1',
                logo_position: this.record.settings.invoice_logo_position || 'left',
                watermark: this.record.settings.watermark || null,
                note: this.record.settings.invoice_manual_notes || null
            }, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then(response => {
                window.open(response.data.fullpath, '_blank');
            }).catch(error => {
                this.showError('Er is een fout opgetreden bij het genereren van het voorbeeld.')
            }).finally(() => {
                this.loading = false;
            });
        },

        deleteWatermark(location) {
            location.watermark = null;
            this.$forceUpdate();
        },

        getLocationError(index, field) {
            const errorKey = `locations.${index}.${field}`;
            if (this.errors && this.errors[errorKey]) {
                return this.errors[errorKey][0];
            }
            return null;
        },

        getLocationErrorType(index, field) {
            const errorKey = `locations.${index}.${field}`;
            return (this.errors && this.errors[errorKey]) ? 'is-danger' : '';
        },

        isDefault(location) {
            if (!location) return false;
            if (this.record.default_location_id) {
                return location.id === this.record.default_location_id;
            }
            // If no default is set, first one is default
            return this.record.locations[0] === location;
        },

        addEmptyLocation() {
            this.record.locations.push({
                name: 'Nieuwe vestiging',
                email: '',
                reply_to: '',
                website: '',
                telephone: '',
                mobile: '',
                btw: '',
                kvk: '',
                bank_name: '',
                bank_iban: '',
                address: '',
                address2: '',
                zipcode: '',
                city: '',
                country: 'Nederland',
                logo: null,
                watermark: null,
                color1: '#118fe4',
                color2: '#000000',
            });
            this.openLocationIndex = this.record.locations.length - 1;
        },

        addDuplicateLocation() {
            const newLocation = JSON.parse(JSON.stringify(this.defaultLocation));
            delete newLocation.id;
            newLocation.name = `${newLocation.name} (Kopie)`;
            this.record.locations.push(newLocation);
            this.openLocationIndex = this.record.locations.length - 1;
        },

        removeLocation(index) {
            const location = this.record.locations[index];
            if (this.isDefault(location)) {
                this.showError('U kunt de standaardvestiging niet verwijderen.');
                return;
            }
            if (this.record.locations.length <= 1) {
                this.showError('U kunt de laatste vestiging niet verwijderen.');
                return;
            }

            this.$buefy.dialog.confirm({
                title: 'Vestiging verwijderen',
                message: 'Weet u zeker dat u deze vestiging wilt verwijderen? Dit kan niet ongedaan worden gemaakt.',
                confirmText: 'Verwijderen',
                cancelText: 'Annuleren',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: () => {
                    this.record.locations.splice(index, 1);
                    this.$buefy.toast.open({message: 'Vestiging verwijderd. Vergeet niet op te slaan.', type: 'is-success'})
                }
            })
        },

        setDefaultLocation(location) {
            if (!this.record.id) {
                this.$buefy.toast.open({message: 'Sla de organisatie eerst op voordat u een nieuwe vestiging als standaard instelt.', type: 'is-warning'})
                return;
            }
            this.record.locations.forEach(l => l.is_default = false);
            location.is_default = true;
            this.$buefy.toast.open({message: `${location.name || 'Vestiging'} is nu de standaardvestiging. Vergeet niet op te slaan.`, type: 'is-success'})
        },

        resetPaynlChanges() {
            if (this.user.is_admin) {
                this.record.paynl_serviceId = this.originalPaynlData.serviceId;
                this.record.paynl_token = this.originalPaynlData.token;
                this.record.paynl_token_secret = this.originalPaynlData.token_secret;
                this.record.paynl_active = this.originalPaynlData.active;
                this.$buefy.toast.open({message: 'Wijzigingen in Pay.nl instellingen ongedaan gemaakt.', type: 'is-success'});
                this.$forceUpdate(); // Force re-render to update the tag
            } else {
                this.showError('Alleen een administrator kan de wijzigingen in Pay.nl instellingen ongedaan maken.');
            }
        }
    },

    watch: {
        'record.name': function(newName) {
            if (this.type === 'new' && this.record.locations.length > 0 && this.record.locations[0].name !== newName) {
                this.record.locations[0].name = newName;
            }
        },
        'record.paynl_active': function(newVal) {
            this.inviteChecklist.paynl_secret = !newVal
            this.inviteChecklist.paynl_location = !newVal
            this.inviteChecklist.paynl_mode = !newVal
        }
    }

}
</script>

<style lang="scss" scoped>
#panel {
    .invoice-layout-tile.is-selected {
        border-color: var(--color1);
    }
}

.mr-2 {
    margin-right: 0.5rem;
}

.paynl-changes-warning {
    .b-tag {
        margin-left: 0.5rem;
    }
}
</style>
